import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actionCreateApiGateWayFactory } from '../../actions/actionCreator';

import { ACTION_KEY as API_GATEWAY_KEYS, ACTION_ATTR as API_GATEWAY_ATTRS } from '../../constants/apiGateWayConstant';

import SearchReport from '../../components/Reports/Search';

function mapStateToProps(state) {
  return {
    relevantReport: state.reportLinkDetail.reportDetail,
  };
}

const mapDispatchToProps = dispatch => ({
  actions: {
    /* eslint max-len : 0 */
    getReportLink: bindActionCreators(actionCreateApiGateWayFactory(API_GATEWAY_KEYS.SEARCH_REPORT, API_GATEWAY_ATTRS.PAYLOAD), dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchReport);



// WEBPACK FOOTER //
// ./src/Containers/Reports/Search.js